
import React from 'react';
import { Users, Sparkles } from 'lucide-react';
import { FeatureList } from './FeatureList';

interface InfoSectionProps {
  signupCount: number;
  isSubmitted: boolean;
}

export const InfoSection: React.FC<InfoSectionProps> = ({ signupCount, isSubmitted }) => {
  return (
    <div className="space-y-4">
      <p className="text-lg font-medium text-hormony-charcoal">
        Your hormones change every day—what if you could track them in real time?
      </p>
      
      <p className="text-gray-600">
        We're launching at-home hormone testing that adapts to your cycle, lifestyle, and stress levels. 
        Get ready for instant insights, trend tracking, and science-backed recommendations personalized just for you.
      </p>
      
      <FeatureList />
      
      <p className="text-hormony-charcoal font-medium">
        Want to be the first to try it? Join the waitlist today!
      </p>
      
      {!isSubmitted ? (
        <div className="text-sm text-gray-500 flex items-center">
          <Users className="h-4 w-4 inline mr-1" />
          <span>{signupCount} users are already on the list!</span>
        </div>
      ) : (
        <div className="text-sm text-hormony-coral font-medium flex items-center">
          <Sparkles className="h-4 w-4 inline mr-1" />
          <span>You're on the list! Stay tuned for early access.</span>
        </div>
      )}
    </div>
  );
};
